module.exports = __webpack_public_path__ + "img/m-hetongguanli.702a4e9f.svg";